// react library imports
import { List, MagnifyingGlass, CalendarBlank, Megaphone,
 Bell, GearSix, SquaresFour, ChatsCircle, BellSimpleRinging  } from 'phosphor-react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import { useState } from 'react';

// import from redux store
import { getUserInformation } from 'Redux/userOnboard/userOnboard';
import { getPreschoolInformation } from 'Redux/preschool/preschool';
import { getUnreadMessageCount } from 'Redux/notification/notification';

// import from apis
import { useGetNotificationQuery } from 'api/realTimeChat/broadcast';

// style imports
import './DashboardNavigation.css';

// redux store imports
import { openSidebar } from '../../Redux/sidebar/sidebar';
import { openNotificationPopup } from 'Redux/notification/notification';

const DashboardNavigation = () => {
    // set state for menu
    const [showMenu, setShowMenu]=useState(false)

    // fetch data and define dispatch which from redux store to send data
    const dispatch=useDispatch()
    const userDetails = useSelector(getUserInformation)
    const preschoolInformation = useSelector(getPreschoolInformation)
    const unreadMessageCount = useSelector(getUnreadMessageCount)
    const senderId = `${preschoolInformation?.id}-principal-${userDetails?.user?.id}`

    // define params
    const params = {
        preschool_id:preschoolInformation?.id,
        member_id: senderId,
        offset: 0,
        limit: 20,
    }

    // fetch data from backend server using rtk query 
    const {refetch} = useGetNotificationQuery(params)    

    // define and destructure data
    const {pathname}=useLocation()    

    // handle open notification popup
    const handleNotificationPopup = () =>{
        dispatch(openNotificationPopup())
        refetch()
        setShowMenu(!showMenu)
    }
  return (
    <div className='dashboard_navigation'>
        <div className="dashboard_navigation_container mues_row_space_between">
            <section className='mues_row_flex mues_search_bar'>
                <List className='list_icon toggle_sidebar' weight='fill'
                onClick={()=>dispatch(openSidebar())}/>
                <MagnifyingGlass className='dashboard_navigation_icon mues_grey_I' weight='bold'/>
                <h5 className='mues_font_weight_400 
                mues_grey_I mues_margin_left_4'>Search</h5>
            </section>    
            <section className='mues_row_space_between dashboard_navigation_item'>
                <NavLink to={"/dashboard/event"}>
                    <CalendarBlank className={`dashboard_navigation_icon
                    ${pathname==="/dashboard/event" ? 'mues_blue':'mues_grey_I'}`}/>
                </NavLink>
                <NavLink to={"/dashboard/broadcast"}>
                    <Megaphone className={`dashboard_navigation_icon
                    ${pathname==="/dashboard/broadcast" ? 'mues_blue':'mues_grey_I'}`}/>
                </NavLink>
                <NavLink to={"/dashboard/chat"}>
                    <ChatsCircle className={`dashboard_navigation_icon
                    ${pathname==="/dashboard/chat" ? 'mues_blue':'mues_grey_I'}`} weight='fill'/>
                </NavLink>
                <div  onClick={handleNotificationPopup}>
                    {unreadMessageCount > 0 ? <BellSimpleRinging className='dashboard_navigation_icon
                    mues_red' weight='fill'/>:<Bell className={`dashboard_navigation_icon 
                    mues_grey_I`}/>}
                </div>
                <NavLink to={"/dashboard/setting"}>
                    <GearSix className={`dashboard_navigation_icon
                    ${pathname==="/dashboard/setting" ? 'mues_blue':'mues_grey_I'}`}/>
                </NavLink>
                <img src="https://mues-solution.s3.ap-south-1.amazonaws.com/svg/mues-tech.svg" 
                alt="mues_logo" loading='lazy' />
            </section>
            <div className='dashboard_navigation_heading'>
                <List className='list_icon' weight='fill'
                onClick={()=>dispatch(openSidebar())}/>
                <div className='logo_container mues_row_center'>
                    <img src="https://mues-solution.s3.ap-south-1.amazonaws.com/svg/mues-tech.svg" 
                    alt="mues_logo" loading='lazy' />
                </div>
                <SquaresFour className='list_icon'
                onClick={()=>setShowMenu(!showMenu)}/>
            </div>
            {showMenu && <div className='menu_item_container mues_column_space_between'>
                <NavLink className="mues_row_flex mues_column_gap_8" to={"/dashboard/event"} onClick={()=>setShowMenu(!showMenu)}>
                    <CalendarBlank className={`dashboard_navigation_icon
                    ${pathname==="/dashboard/event" ? 'mues_blue':'mues_grey_I'}`} weight='fill' />
                    <h6 className={`mues_font_weight_600
                    ${pathname==="/dashboard/event" ? 'mues_blue':'mues_grey_I'}`}>Calenders</h6>
                </NavLink>
                <NavLink className="mues_row_flex mues_column_gap_8" to={"/dashboard/broadcast"} onClick={()=>setShowMenu(!showMenu)}>
                    <Megaphone className={`dashboard_navigation_icon
                    ${pathname==="/dashboard/broadcast" ? 'mues_blue':'mues_grey_I'}`} weight='fill'/>
                    <h6 className={`mues_font_weight_600
                    ${pathname==="/dashboard/broadcast" ? 'mues_blue':'mues_grey_I'}`}>Broadcast</h6>
                </NavLink>
                <NavLink className="mues_row_flex mues_column_gap_8" to={"/dashboard/chat"}>
                    <ChatsCircle className={`dashboard_navigation_icon mues_grey_I
                    ${pathname==="/dashboard/chat" && 'mues_blue'}`} weight='fill'/>
                    <h6 className={`mues_font_weight_600
                    ${pathname==="/dashboard/chat" ? 'mues_blue':'mues_grey_I'}`}>Chat</h6>
                </NavLink>
                <NavLink className="mues_row_flex">
                    <div  onClick={handleNotificationPopup}>
                    {unreadMessageCount > 0 ? <div className='mues_row_center mues_column_gap_8'>
                        <BellSimpleRinging className='dashboard_navigation_icon
                    mues_red' weight='fill'/>
                    <h6 className={`mues_font_weight_600 mues_grey_I`}>Notification</h6>
                    </div>:<div className='mues_row_center mues_column_gap_8'>
                    <Bell className={`dashboard_navigation_icon 
                    mues_grey_I`} weight='fill'/>
                    <h6 className={`mues_font_weight_600 mues_grey_I`}>Notification</h6>
                    </div>}
                </div>
                </NavLink>
                <NavLink className="mues_row_flex mues_column_gap_8" to={"/dashboard/setting"} onClick={()=>setShowMenu(!showMenu)}>
                    <GearSix className={`dashboard_navigation_icon
                    ${pathname==="/dashboard/setting" ? 'mues_blue':'mues_grey_I'}`} weight='fill'/>
                    <h6 className={`mues_font_weight_600
                    ${pathname==="/dashboard/setting" ? 'mues_blue':'mues_grey_I'}`}>Setting</h6>
                </NavLink>
                <link></link>
            </div>}
        </div>
    </div>
  )
}

export default DashboardNavigation